"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function FrequentlyAskedQuestions() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="19366" id="frequently-asked-questions" className="relative w-full py-24 overflow-hidden bg-[#362242] text-white">
      <div className="absolute top-0 left-0 w-[600px] h-[600px] bg-purple-600/10 rounded-full blur-[120px] -translate-x-1/3 -translate-y-1/3 pointer-events-none" />
      <div className="absolute bottom-0 right-0 w-[600px] h-[600px] bg-purple-600/10 rounded-full blur-[120px] translate-x-1/3 translate-y-1/3 pointer-events-none" />

      <div ref={ref} className={cn("container mx-auto px-4 relative z-10 transition-all duration-1000 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8")}>
        <div className="max-w-[800px] mx-auto">
          <h2 className="text-3xl md:text-5xl font-bold text-center mb-16 tracking-tight font-sans text-white uppercase">
            Frequently Asked Questions
          </h2>

          <div className="text-base text-[#CECECE] pb-8 leading-relaxed font-sans">
            <div className="space-y-10">
              <div>
                <h3 className="text-lg md:text-xl font-bold text-white mb-3 uppercase tracking-wide">What is a geotechnical investigation and when is it required?</h3>
                <p>A geotechnical investigation evaluates subsurface soil conditions to determine how a site will support a proposed structure. It typically includes soil borings, test pits, and laboratory testing to assess bearing capacity, settlement, and groundwater conditions.</p>
              </div>

              <div>
                <h3 className="text-lg md:text-xl font-bold text-white mb-3 uppercase tracking-wide">When should geotechnical testing be performed in the development process?</h3>
                <p>Geotechnical investigations are typically performed during the early design phase of a project, before foundation design and site planning are finalized. Early testing helps identify soil conditions and avoid costly design changes later.</p>
              </div>

              <div>
                <h3 className="text-lg md:text-xl font-bold text-white mb-3 uppercase tracking-wide">How long does a geotechnical investigation take?</h3>
                <p>Most field investigations can be completed in one to several days depending on project size. Laboratory testing and preparation of the geotechnical report typically follow within a few weeks.</p>
              </div>

              <div>
                <h3 className="text-lg md:text-xl font-bold text-white mb-3 uppercase tracking-wide">What types of projects do you work on?</h3>
                <p>We provide geotechnical services for residential homes, commercial developments, infrastructure projects, and site development requiring soil testing and subsurface investigation.</p>
              </div>

              <div>
                <h3 className="text-lg md:text-xl font-bold text-white mb-3 uppercase tracking-wide">Do I need a perc test for my property?</h3>
                <p>Perc testing is required when evaluating a property for a septic system. The test measures how quickly water infiltrates into the soil to determine if the site is suitable for onsite wastewater disposal.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}